import { useSyncExternalStore } from "react";

// Choice for new uploads (official catalogue and developer spaces): "auto" (suggested from the APK), "app" or "minisite".
let current = "auto";
const subs = new Set();

export const uploadCategory = () => (current !== "auto" ? current : undefined);

export const setUploadCategory = (c) => {
  current = c;
  subs.forEach((f) => f());
};

export const useUploadCategory = () =>
  useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => current);
